exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.store[data-v-3e576f81] {\n  margin-right: 20px;\n}\n.link-data[data-v-3e576f81] {\n  -ms-flex: 1;\n      flex: 1;\n  padding-left: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3e576f81","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/template_links/distributor_index.vue
// module id = 1401
// module chunks = 0